(function () {
	'use strict';
	$(document).ready(function () {

		activateShuffleOnVisible(".fh-shuffle", ".homepage .report");

		$(".js-modal-btn").modalVideo({channel: 'vimeo'});

		const heroSwiper = new Swiper('.swiper.swiper-hero', {
			loop: false,
			spaceBetween: 30,
		});

		$('.swiper-hero-nav-btn').on('click', function () {
			const slideId = $(this).data('slideid');
			heroSwiper.slideTo(slideId);
			$('.swiper-hero-nav-btn').removeClass('active');
			$(this).addClass('active');
		});

		heroSwiper.on('slideChange', function () {
			const currentSlide = heroSwiper.activeIndex;
			$('.swiper-hero-nav-btn').removeClass('active');
			$('.swiper-hero-nav-btn[data-slideid="' + currentSlide + '"]').addClass('active');

		});

		const quotationSwiper = new Swiper('.swiper.swiper-quotation', {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.swiper-navigation .swiper-pagination',
				clickable: true,
			},
		});

		$('.swiper-quotations-nav-btn').on('click', function () {
			const slideId = $(this).data('slideid');
			quotationSwiper.slideTo(slideId);
			$('.swiper-hero-nav-btn').removeClass('active');
			$(this).addClass('active');
		});

		quotationSwiper.on('slideChange', function () {
			const currentSlide = quotationSwiper.activeIndex;
			$('.swiper-quotations-nav-btn').removeClass('active');
			$('.swiper-quotations-nav-btn[data-slideid="' + currentSlide + '"]').addClass('active');

		});

		const targetsSwiper = new Swiper('.swiper.swiper-targets', {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: false,
			navigation: {
				prevEl: document.querySelector('.targets .swiper-nav .swiper-button-prev'),
				nextEl: document.querySelector('.targets .swiper-nav .swiper-button-next'),
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 2,
				}
			}
		});

		document.querySelectorAll('.swiper.swiper-summary').forEach((element) => {
			const sliderWrapper = element.closest('.summary-slider');

			new Swiper(element, {
				slidesPerView: 1,
				spaceBetween: 25,
				loop: false,
				navigation: {
					prevEl: sliderWrapper.querySelector('.swiper-nav .swiper-button-prev'),
					nextEl: sliderWrapper.querySelector('.swiper-nav .swiper-button-next'),
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
				},
			});
		});

		document.querySelectorAll('.swiper.swiper-strategy').forEach((element) => {
			const sliderWrapper = element.closest('.strategy-slider');

			new Swiper(element, {
				slidesPerView: 1,
				spaceBetween: 25,
				loop: false,
				navigation: {
					prevEl: sliderWrapper.querySelector('.swiper-nav .swiper-button-prev'),
					nextEl: sliderWrapper.querySelector('.swiper-nav .swiper-button-next'),
				},
			});
		});
	});
}(jQuery));
